(ns frontend.view.user-management.events
  (:require
   [common.schema.registry :as registry]
   [common.localization :as loc]
   [frontend.state.current-session :as session]
   [common.util :as cu]
   [clojure.string :as string]
   [clojure.edn :as edn]
   [frontend.state.account :as account]
   [frontend.actions.entity :as entity-actions]
   [frontend.view.modals.processing.view :as processing]
   [frontend.view.modals.events :as modals]
   [frontend.actions.guest :as guest-actions]
   [frontend.logging :as logging]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.actions.account :as account-actions]
   [common.entity :as entity]))

(defn field-column
  [tenant-schema attribute options]
  (let [field-schema (registry/get-field-schema tenant-schema attribute)]
    (merge {:column/key       attribute
            :column/label     (loc/field-name attribute field-schema)
            :column/data-type (:field/data-type field-schema)}
           options)))

(defn team-key
  [team]
  (keyword "team" (str "id_" (:db/id team))))

(defn team-id
  [team-key]
  (-> team-key
      (name)
      (string/split #"_")
      (last)
      (edn/read-string)))

(defn toggle-role
  [{:keys [column-meta row-data on? state]}]
  (let [role-id (:role-id row-data)
        new-role-kw (if on?
                      :role/admin
                      :role/user)]
    (account/update-account!
     (fn [args]
       (logging/info "Success! " args))
     (fn [err]
       (logging/error "Error! " err))
     {:db/id (:id row-data)}
     {:db/id     role-id
      :common/disabled? false
      :role/role new-role-kw}
     true)))

(defn toggle-team-membership
  [{:keys [column-key row-data on? state]}]
  (let [team-key column-key
        team-id (team-id team-key)
        team (get @session/entities team-id)
        account-id (:id row-data)
        team-members (if on?
                       (conj (:team/members team) account-id)
                       (disj (:team/members team) account-id))]
    (entity-actions/*->entity-update! team-id
                                      {:team/members team-members}
                                      (fn [& args]
                                        (swap! state dissoc team-key))
                                      (fn [& err]
                                        (logging/error "Error " err)
                                        (swap! state dissoc team-key)))))

(defn re-invite!
  [{:keys [account role on-submit!]}]
  (modals/open-modal!
   processing/modal-key
   {:title (loc/tr :reinvite-user [(:account/email account)])
    :start-process! (fn [state]
                      (account/re-invite-account!
                       (fn [resp]
                         (swap! state assoc :process/status :process.status/success)
                         (when on-submit!
                           (on-submit!)))
                       (fn [err]
                         (swap! state assoc :process/status :process.status/failed)
                         (when on-submit!
                           (on-submit!)))
                       account
                       role))}))

(defn deactivate-guest!
  [role-entity target-entity state]
  (let [data {:role-id (:db/id role-entity)}
        on-success! (fn [args]
                      (swap! state dissoc :selected-ssg-id))
        on-error! (fn [err]
                    (swap! state dissoc :selected-ssg-id))]
    (modals/open-modal! confirmation/modal-key
                        {:body           [:div (loc/tr :guest/delete-guest-info)
                                          [:p (loc/tr :i-understand-that)]]
                         :confirms       [[:tasks
                                           (loc/tr (if (-> target-entity
                                                       :entity/type
                                                       (= :entity.type/oppo))
                                                 :guest/tasks-info-deal
                                                 :guest/tasks-info))]]
                         :checkbox-class "guest-checkbox"
                         :body-class     "guest-confirm-body"
                         :confirm-text   (loc/tr :guest/remove-access-right)
                         :checkbox-text  (loc/tr :there-is-no-undo-for-this)
                         :on-confirm     (fn []
                                           (guest-actions/*->revoke! data
                                                                     on-success!
                                                                     on-error!))})))

(defn invite-guest!
  [{:keys [target-id person email role-kw on-submit!]}]
  (let [{:keys [person/first-name person/last-name]} person
        data {:target-id target-id
              :person-id (:db/id person)
              :account   (merge {:account/email email}
                                (if first-name
                                  {:account/first-name first-name})
                                (if last-name
                                  {:account/last-name last-name}))
              :role      role-kw}]
    (modals/open-modal!
     processing/modal-key
     {:title (loc/tr :reinvite-user [(:person/universal-email-address person)])
      :start-process! (fn [state]
                        (account-actions/*->invite-guest
                         data
                         (fn [resp]
                           (swap! state assoc :process/status :process.status/success)
                           (when on-submit!
                             (on-submit!)))
                         (fn [err]
                           (swap! state assoc :process/status :process.status/failed)
                           (when on-submit!
                             (on-submit!)))))})))

(defn re-invite-guest!
  [{:keys [target-id role-id account-name on-submit!]}]
  (let [data {:target-id target-id
              :role-id   role-id}]
    (modals/open-modal!
     processing/modal-key
     {:title (loc/tr :reinvite-user [account-name])
      :start-process! (fn [state]
                        (account-actions/*->re-invite-guest
                         data
                         (fn [resp]
                           (swap! state assoc :process/status :process.status/success)
                           (when on-submit!
                             (on-submit!)))
                         (fn [err]
                           (swap! state assoc :process/status :process.status/failed)
                           (when on-submit!
                             (on-submit!)))))})))

(defn update-guest!
  [{:keys [account-id first-name last-name account-name on-submit!]}]
  (let [data (cu/remove-empty-vals {:db/id account-id
                                    :account/first-name first-name
                                    :account/last-name last-name})]
    (modals/open-modal!
     processing/modal-key
     {:title (loc/tr :modify-guest-user [account-name])
      :start-process! (fn [state]
                        (account-actions/*->update-guest
                         data
                         (fn [resp]
                           (swap! state assoc :process/status :process.status/success)
                           (when on-submit!
                             (on-submit!)))
                         (fn [err]
                           (swap! state assoc :process/status :process.status/failed)
                           (when on-submit!
                             (on-submit!)))))})))

(defn account-role
  [account]
  (let [role-id (:role/role-id account)
        role (get @session/entities role-id)]
    role))

(defn filter-by-status
  [state accounts]
  (let [show-deactivated? (:show-deactivated? @state)
        show-deactivated-guests? (:show-deactivated-guests? @state)]
    (if (or show-deactivated?
            show-deactivated-guests?)
      (->> accounts
           (sort-by (fn [account]
                      (not (:common/disabled? (account-role account))))))
      (->> accounts
           (remove (fn [account]
                     (:common/disabled? (account-role account))))))))

(defn filter-accounts-by-search
  [state search-value accounts]
  (let [search-str-lc (cu/str-trim-lcase search-value)]
    (if (empty? search-str-lc)
      accounts
      (->> accounts
           (filter (fn [account]
                     (string/includes? (string/lower-case (entity/display-string account :long))
                                       search-str-lc)))))))

(defn filter-teams-by-search
  [state search-value teams]
  (let [search-str-lc (cu/str-trim-lcase search-value)]
    (if (empty? search-str-lc)
      teams
      (->> teams
           (filter (fn [{:keys [team/name] :as team}]
                     (string/includes? (string/lower-case name) search-str-lc)))))))

(defn filter-insiders-by-search
  [state search-value insiders]
  (let [search-str-lc (cu/str-trim-lcase search-value)]
    (if (empty? search-str-lc)
      insiders
      (->> insiders
           (filter (fn [{:keys [insider-group/name] :as team}]
                     (string/includes? (cu/str-trim-lcase name) search-str-lc)))))))

(defn disable-team!
  [team-id]
  (entity-actions/*->disable! team-id
                              (fn [& args])
                              (fn [& err]
                                (logging/error "Error " err))))

(defn disable-insider-group!
  [insider-group-id]
  (entity-actions/*->disable! insider-group-id
                              (fn [& args])
                              (fn [& err]
                                (logging/error "Error " err))))

(defn get-cell-value
  [props]
  (let [get-value-fn (aget props "getCellValue")
        value (if (instance? js/Function get-value-fn)
                (get-value-fn props)
                (aget props "value"))]
    value))
